import React from 'react';

const Notfound = () => {
    return (
        <div>
            <h2>No Result Found</h2>
        </div>
    );
};

export default Notfound;